import React, {useContext} from "react";
import UserContext from "../../common/UserContext";

//components
import {ColumnMenu, DateCell, NoWrapCell, TextAlignMiddleCell} from "../../common/Grid";

//kendo
import {orderBy} from "@progress/kendo-data-query";
import {Grid, GridColumn} from "@progress/kendo-react-grid";

//multilingual
import {
    assignQtyKey,
    descriptionKey,
    endDateKey,
    licenseTypeKey,
    mainMessages,
    productNumberKey,
    qtyKey, startDateKey,
} from "../../../assets/text/MultilingualText";
import {useLocalization} from "@progress/kendo-react-intl";
import {GeneralContext} from "../FSARequestLicenseContext";

export const RequestDownloadGrid = (props) => {
    const {
        siteLanguageDefault,
    } = useContext(UserContext);

    const {
        productNumKey,
        licenseStartDateKey,
        licenseEndDateKey,
    } = useContext(GeneralContext)

    const {
        items
    } = props
    const localization = useLocalization();

    return (
        <Grid
            className={'fsa-request-download-grid'}
            data={orderBy(items, [{
                field: productNumKey,
                dir: "desc"
            }])}
            scrollable={'none'}
            sortable={false}
        >
            <GridColumn
                field={productNumKey}
                title={localization.toLanguageString(productNumberKey, mainMessages[siteLanguageDefault][productNumberKey])}
                cell={NoWrapCell}
            />
            <GridColumn
                field="description"
                title={localization.toLanguageString(descriptionKey, mainMessages[siteLanguageDefault][descriptionKey])}
            />
            <GridColumn
                field="quantity"
                title={localization.toLanguageString(qtyKey, mainMessages[siteLanguageDefault][qtyKey])}
                cell={TextAlignMiddleCell}
            />
            <GridColumn
                field="assign_quantity"
                title={localization.toLanguageString(assignQtyKey, mainMessages[siteLanguageDefault][assignQtyKey])}
                cell={TextAlignMiddleCell}
            />

            <GridColumn
                field="license_type_text"
                title={localization.toLanguageString(licenseTypeKey, mainMessages[siteLanguageDefault][licenseTypeKey])}
                cell={NoWrapCell}
            />

            <GridColumn
                field={licenseStartDateKey}
                title={localization.toLanguageString(startDateKey, mainMessages[siteLanguageDefault][startDateKey])}
                filter={'date'}
                cell={DateCell}
            />

            <GridColumn
                field={licenseEndDateKey}
                title={localization.toLanguageString(endDateKey, mainMessages[siteLanguageDefault][endDateKey])}
                filter={'date'}
                cell={DateCell}
            />
        </Grid>
    )
}
